import React from "react";
import "./About.css";
import aboutBanner from "../../images/about_banner.jpg";
import aboutBody1 from "../../images/about_body1.jpg";
import aboutBody2 from "../../images/about_body2.jpg";

const About = () => (
  <div className="about-page">
    <div className="about-banner">
      <img src={aboutBanner} alt="About Banner" className="about-banner-img" />
      <div className="about-banner-overlay">
        <h1>About Us</h1>
        <div className="about-subtitle">Empowering Financial Inclusion & Growth</div>
      </div>
    </div>
    {/* About Us Zig-Zag Section */}
    <section className="about-zigzag-section">
      <div className="about-zigzag-row">
        <div className="about-zigzag-image">
          <img src={aboutBody1} alt="Naman Finlease Team" />
        </div>
        <div className="about-zigzag-content">
          <p>
            Naman Finlease Pvt. Ltd is a promising Fintech company and registered NBFC. With a team of experienced professionals in the financial industry, we offer a wide range of financial services to our clients, including loans, investments, insurance, and more.
          </p>
        </div>
      </div>
      <div className="about-zigzag-row">
        <div className="about-zigzag-content">
          <p>
            Our goal is to provide affordable and accessible financial services to individuals and businesses, especially those who are underserved by traditional financial institutions. We believe that financial inclusion is key to economic growth and stability, and we are committed to helping our clients achieve their financial goals.
          </p>
        </div>
        <div className="about-zigzag-image">
          <img src={aboutBody2} alt="Naman Finlease Office" />
        </div>
      </div>
    </section>
    {/* Mission & Vision Cards */}
    <section className="about-cards-section">
      <div className="about-cards-grid">
        <div className="about-card">
          <div className="about-card-icon mission-icon">
            <svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="24" cy="24" r="20" stroke="#1565c0" strokeWidth="2.5"/><path d="M24 14v10l7 7" stroke="#1565c0" strokeWidth="2.5" strokeLinecap="round"/></svg>
          </div>
          <h3>Our Mission</h3>
          <p>To provide <strong>affordable</strong> and <strong>accessible</strong> financial services to all, empowering individuals and businesses to achieve their dreams and contribute to economic growth.</p>
        </div>
        <div className="about-card">
          <div className="about-card-icon vision-icon">
            <svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="8" y="12" width="32" height="24" rx="4" stroke="#00BFAE" strokeWidth="2.5"/><path d="M16 20h16M16 24h8" stroke="#00BFAE" strokeWidth="2.5" strokeLinecap="round"/></svg>
          </div>
          <h3>Our Vision</h3>
          <p>To be a <strong>trusted leader</strong> in the fintech industry, driving <strong>financial inclusion</strong> and innovation for a brighter, more secure future for our clients and communities.</p>
        </div>
      </div>
    </section>
  </div>
);

export default About; 